import { centroid } from "@turf/turf";
import { parseGeoData } from "senf-shared";

export function getCenterOfFeature(featureData) {
  const geoData = parseGeoData(featureData);

  // Ensure geoData is defined and has a valid structure
  if (!geoData || !geoData.features || !geoData.features.length) {
    console.error("Invalid GeoJSON data");
    return null;
  }

  // Get the first feature from the GeoJSON data
  const feature = geoData.features[0];

  // If the feature type is Point, return the coordinates directly
  if (feature.geometry.type === "Point") {
    return feature.geometry.coordinates;
  }

  // If the feature type is LineString, return the first coordinates of the line
  if (feature.geometry.type === "LineString") {
    return feature.geometry.coordinates[0];
  }

  // Calculate the centroid for other feature types
  const center = centroid(feature);

  // Extract the centroid coordinates as an array [longitude, latitude]
  const centroidCoords = center.geometry.coordinates;

  return centroidCoords;
}
